import { render } from "./LabStore.vue?vue&type=template&id=3f6fe5b6&scoped=true"
import script from "./LabStore.vue?vue&type=script&lang=js"
export * from "./LabStore.vue?vue&type=script&lang=js"

import "./LabStore.vue?vue&type=style&index=0&id=3f6fe5b6&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f6fe5b6"]])

export default __exports__